import { render, staticRenderFns } from "./SearchListCard.vue?vue&type=template&id=8c6a5182&scoped=true"
import script from "./SearchListCard.vue?vue&type=script&lang=js"
export * from "./SearchListCard.vue?vue&type=script&lang=js"
import style0 from "./SearchListCard.vue?vue&type=style&index=0&id=8c6a5182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a5182",
  null
  
)

export default component.exports